/* ============
 * Mutation types for the reminder module
 * ============
 *
 * The mutation types that are available
 * on the reminder module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  SET_REMINDER: null,
  FETCH_REMINDER_LIST: null,
  FETCH_REMINDER_LIST_SUCCESS: null,
  FETCH_REMINDER_LIST_FAIL: null,
  CREATE_REMINDER: null,
  CREATE_REMINDER_SUCCESS: null,
  CREATE_REMINDER_FAIL: null,
  CREATE_REMINDER_NOT_CREATED: null,
  UPDATE_REMINDER: null,
  UPDATE_REMINDER_SUCCESS: null,
  UPDATE_REMINDER_FAIL: null,
  REMINDER_NOT_UPDATED: null
});
